<template>
  <gemmologist
    :staff-type="2"
    staff-type-name="辅助人员"></gemmologist>
</template>

<script>
import Gemmologist from './index.vue'
export default {
  name: 'AppraisalAssistants',
  components: {
    Gemmologist
  }

}
</script>
